<template>
    <div>
        <random-call-cordova v-if="cordova" />
        <random-call-session v-else-if="currentRandomCall" />
        <random-call-rating v-else-if="rating.showing" />
        <random-call-lobby v-else />
    </div>
</template>

<script>
import { mapState } from "vuex";

import RandomCallLobby from "@/components/randomCall/RandomCallLobby";
import RandomCallSession from "@/components/randomCall/RandomCallSession";
import RandomCallCordova from "@/components/randomCall/RandomCallCordova";
import RandomCallRating from "@/components/randomCall/RandomCallRating";

export default {
    components: {
        RandomCallLobby,
        RandomCallSession,
        RandomCallCordova,
        RandomCallRating,
    },
    computed: {
        ...mapState("system", ["cordova"]),
        ...mapState("randomCall", ["currentRandomCall", "rating"]),
    },
    created() {
        this.$store.dispatch("randomCall/fetchLobby");
        this.$store.dispatch("randomCall/subscribeQueue");
    },
    beforeDestroy() {
        this.$store.dispatch("randomCall/unsubscribeQueue");
        if (this.$store.state.randomCall.inQueue) {
            this.$store.dispatch("randomCall/leaveQueue");
        }
    },
};
</script>
